const errorMap = {
  'auth/invalid-email': 'Invalid login credentials.',
  'auth/user-disabled': 'Your account has been disabled. Please contact your administrator for assistance.',
  'auth/user-not-found': 'Invalid login credentials.',
  'auth/wrong-password': 'Invalid login credentials.',
  'auth/requires-recent-login':
    'Recent login require for this operation. Please log out and log back in to complete this change.',
  'auth/email-already-in-use': 'Email is already in use.',
  'auth/weak-password':
    'Password is too weak. Please choose a more complex password.',
  'auth/invalid-verification-code': 'Invalid verification code',
  'auth/too-many-requests':
    'Too many requests. Please try again later or reset your password to unlock your account.',
  'auth/invalid-login-credentials': 'Invalid login credentials.',
  'auth/invalid_login_credentials': 'Invalid login credentials.',
  'auth/invalid-credential': 'Invalid login credentials.',
  'auth/network-request-failed': 'Please check your internet connection.',
  'functions/internal': 'An internal error occurred.',
};

export default errorMap;

export const getErrorMessage = (error: string): string => {
  const message = errorMap[error];
  if (Boolean(message)) return message;
  return 'An unknown error occurred. Contact techsupport@hawkindynamics.com if this issue persists.';
};
